export const staticRoutes = {
  static_routes: "static_route",
  route_private: "route_private",
  route_active: "route_active",
  route_dest_addr: "route_dest_address",
  route_subnet: "route_net_mask",
  route_gateway_addr: "route_gateway",
};

export default staticRoutes;
